import { useState, useEffect, useRef } from 'react'

interface PerformanceMemory {
  jsHeapSizeLimit?: number
  totalJSHeapSize?: number
  usedJSHeapSize?: number
}

declare global {
  interface Performance {
    memory?: PerformanceMemory
  }
}

export const usePerformance = () => {
  const [memoryUsage, setMemoryUsage] = useState(0)
  const [fps, setFps] = useState(60)
  
  const frameCountRef = useRef(0)
  const lastTimeRef = useRef<number | null>(null)
  const rafIdRef = useRef<number | null>(null)

  useEffect(() => {
    // Используем setTimeout вместо прямого вызова setState
    const timerId = setTimeout(() => {
      if (typeof window !== 'undefined' && typeof performance !== 'undefined') {
        lastTimeRef.current = performance.now()
        
        const update = () => {
          if (!lastTimeRef.current) return

          // Memory usage
          if ('memory' in performance && performance.memory?.usedJSHeapSize) {
            const usedMB = Math.round(performance.memory.usedJSHeapSize / 1048576)
            setMemoryUsage(usedMB)
          }

          // FPS calculation
          frameCountRef.current++
          const currentTime = performance.now()
          const delta = currentTime - lastTimeRef.current

          if (delta >= 1000) {
            setFps(Math.round((frameCountRef.current * 1000) / delta))
            frameCountRef.current = 0
            lastTimeRef.current = currentTime
          }

          rafIdRef.current = requestAnimationFrame(update)
        }

        rafIdRef.current = requestAnimationFrame(update)
      }
    }, 0)

    return () => {
      clearTimeout(timerId)
      if (rafIdRef.current) {
        cancelAnimationFrame(rafIdRef.current)
      }
    }
  }, [])

  return { memoryUsage, fps }
}